import { SectionReveal } from './SectionReveal';

export const PageHeader = ({ title, subtitle, meta }) => {
  return (
    <section className="pt-32 md:pt-40 pb-14 sm:pb-20">
      <div className="max-w-[1200px] mx-auto px-5 sm:px-8">
        <SectionReveal>
          {meta && (
            <p className="font-mono-meta text-[hsl(var(--bk-fg-subtle))] mb-4">{meta}</p>
          )}
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-[-0.02em] leading-[0.95] text-[hsl(var(--bk-fg))]">
            {title}
          </h1>
          {subtitle && (
            <p className="font-body text-base md:text-lg text-[hsl(var(--bk-fg-muted))] mt-6 max-w-[600px] leading-relaxed">
              {subtitle}
            </p>
          )}
        </SectionReveal>
      </div>
    </section>
  );
};
